/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { getImage } from '@utils/media';
import { useMedia } from '@api/hooks';

const DualTextBlockItem = ({ module: { content }, errors }) => {
  const { media } = useMedia(getImage(content?.leftTextBlock));

  return (
    <InfoItem.WithError error={errors} size="large" image={media.src} description={content?.leftTextBlock?.title}>
      Dual Text Block
    </InfoItem.WithError>
  );
};

export default DualTextBlockItem;
